import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page" }

import {API_URL} from "@/resourses/api";

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      type: "primary",
      tag: "a",
      size: "large",
      href: `${_unref(API_URL)}/builder/users/login`
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Войти через SSO ", -1)
      ]))]),
      _: 1
    }, 8, ["href"])
  ]))
}
}

})